import * as runtime from '@/api/runtime'
import {
  BatchStatisticsLendRequest,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsLendRequestToJSON,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'

import {
  BatchStatisticsPageLoadResult,
  BatchStatisticsPageLoadResultFromJSON
} from '@/api/models/batch/BatchStatisticsPageLoadResult'

import {
  BatchStatisticsGetSelectItemRequest,
  BatchStatisticsGetSelectItemRequestToJSON
} from '@/api/models/batch/BatchStatisticsGetSelectItemRequest'
import {
  BatchStatisticsGetSelectItemResult,
  BatchStatisticsGetSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsGetSelectItemResult'
import {
  BatchStatisticsGetPredefinedSettingRequest,
  BatchStatisticsGetPredefinedSettingRequestToJSON
} from '@/api/models/batch/BatchStatisticsGetPredefinedSettingRequest'
import {
  BatchStatisticsGetPredefinedSettingResult,
  BatchStatisticsGetPredefinedSettingResultFromJSON
} from '@/api/models/batch/BatchStatisticsGetPredefinedSettingResult'

/**
 * 帳票作成
 */
export class BatchStatisticsApi extends runtime.BaseAPI {
  async createLend(request: BatchStatisticsLendRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/lend`,
      BatchStatisticsLendRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  /**
   * 検索状態登録
   * @param request
   */
  async registPattern(
    request: BatchStatisticsLendRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestPost(
      `/batch/statistics/regist_pattern`,
      BatchStatisticsLendRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchStatisticsPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * セレクト項目取得
   * @param request
   */
  async getSelectItem(
    request: BatchStatisticsGetSelectItemRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_select_item`,
      BatchStatisticsGetSelectItemRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 登録済み出力条件取得
   * @param request
   */
  async getPredefinedSetting(
    request: BatchStatisticsGetPredefinedSettingRequest
  ): Promise<BatchStatisticsGetPredefinedSettingResult> {
    const response = await this.requestGet(
      `/batch/statistics/list_item`,
      BatchStatisticsGetPredefinedSettingRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetPredefinedSettingResultFromJSON(jsonValue)
    ).value()
  }
}
